const state = {
  notifications_list: []
}

const getters = {
  notificationsCount: function(state) {
    return state.notifications_list.length
  },
  notificationsList: function(state) {
    return state.notifications_list
  },
  unreadNotificationsCount: function(state) {
    var count = 0
    for (var i = 0; i < state.notifications_list.length; i++) {
        if(state.notifications_list[i].read_at == null){
          count++;
        }
    }
    return count
  },
}

const mutations = {
  loadNotifications: function(state, notifications) {
    state.notifications_list = notifications
  },
  addOrReplaceNotification: function(state, notification) {
    if(state.notifications_list.find(notification.id)){
      state.notifications_list.replaceById(notification)
    }else{
      state.notifications_list.unshift(notification)
    }
  },
  removeNotification: function(state, notification) {
    state.notifications_list.remove(notification)
  },
  readAllNotifications: function(state){
    for (var i = 0; i < state.notifications_list.length; i++) {
      Vue.set(state.notifications_list[i], 'read_at', new Date());
    }
  },
  resetNotifications: function(state) {
    state.notifications_list = []
  }
}

const actions = {
  resetNotifications (context) {
    context.commit('resetNotifications', [])
  },
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/notification.js